// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".RelrfJbVozi1xy8AWBah {\n  width: 53px;\n  height: 4px;\n  display: block;\n  margin: 8px auto;\n  background-color: #0368a1;\n}\n", "",{"version":3,"sources":["webpack://./src/components/PageDivider/PageDivider.module.less"],"names":[],"mappings":"AAEA;EACC,WAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;AADD","sourcesContent":["@import '../../styles/theme.less';\n\n.divider {\n\twidth: 53px;\n\theight: 4px;\n\tdisplay: block;\n\tmargin: 8px auto;\n\tbackground-color: @primary-color;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"divider": "RelrfJbVozi1xy8AWBah"
};
export default ___CSS_LOADER_EXPORT___;
